"use strict";

angular.module("vendor")
.factory("ImportLog", function($resource, gettextCatalog, FlashBag, appConfig) {
    var importLogListing = $resource(appConfig.API_SERVER + "/import/vendor/logs/", {}, {
        query: {
            method: "GET",
            isArray: false
        }
    });

    function getStatusLocalized() {
        return {
            new: gettextCatalog.getString("New"),
            modify: gettextCatalog.getString("Modified"),
            error: gettextCatalog.getString("Error")
        }
    }

    function getStatusFilter() {
        var values = [];
        var filterValues = getStatusLocalized();

        angular.forEach(filterValues, function(value, key) {
            values.push({
                Value: key,
                Name: value
            });
        });

        return values;
    }

    return {
        query: function(search, page, filters) {
            var params = {
                search: search,
                page: page,
            };
            params = angular.extend(params, filters);
            return importLogListing.query(params,
                function(data) {
                },
                function errorCallback(response) {
                    FlashBag.apiError(response);
                }
            );
        },
        getStatusFilter: getStatusFilter,
        getStatusLocalized: getStatusLocalized
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/import/import-log.factory.js
// module id = 1013
// module chunks = 0